<template>
  <div>
    <naj-box :title="local.embassy.title">
      <v-row>
        <v-col
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.embassy.name"
            :value.sync="formModel.organizationId"
            :value-name.sync="formModel.organizationName"
            :items="embassies"
            item-text="organizationName"
            item-value="id"
            item-description="unifiedNumber"
            validates="required|isIdAllowed"
            :disabled="isViewMode"
            @change="onOrganizationChange"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <naj-address
      :title="local.titleHeader.addressEmbassy"
      :form-model="formModel.placeAddress"
      :required="required"
      :is-view-mode="isViewMode"
    ></naj-address>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  inject: ['$validator'],
  props: ['formModel', 'required', 'isViewMode'],
  computed: { ...mapLUTState(['embassies']) },
  created() {
    this.getEmbassies();
  },
  methods: {
    ...mapLUTActions(['getEmbassies']),
    onOrganizationChange(organizationId) {
      const embassy = this.embassies.find(e => e.id === organizationId);
      this.$set(this.formModel, 'name', embassy ? embassy.organizationName : undefined);
      this.$set(this.formModel, 'unifiedNumber', embassy ? embassy.unifiedNumber : undefined);
    },
  },
};
</script>
